import { render, staticRenderFns } from "./GenerateJurnal.vue?vue&type=template&id=12b17041"
import script from "./GenerateJurnal.vue?vue&type=script&lang=js"
export * from "./GenerateJurnal.vue?vue&type=script&lang=js"
import style0 from "./GenerateJurnal.vue?vue&type=style&index=0&id=12b17041&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports